import { FileService } from "./../../services/file.service";
import { Component, OnInit } from "@angular/core";
import { ApiService } from "../../services/api.service";
import { UtilsService } from "../../services/utils.service";
import AppConstants from "../../constants/AppConstants";
import { LocationsService } from "../../services/locations.service";
import { AttractionsService } from "../../services/attractions.service";
import { Subject } from "rxjs/Subject";
import { debounceTime } from "rxjs/operators";

@Component({
  selector: "app-all-photos",
  templateUrl: "./all-photos.component.html",
  styleUrls: ["./all-photos.component.scss"],
})
export class AllPhotosComponent implements OnInit {
  private pageIndex: number;
  //TODO:Check photos
  constructor(
    private graphqlService: ApiService,
    private utilsService: UtilsService,
    private locationService: LocationsService,
    private attractionService: AttractionsService,
    private fileService: FileService
  ) {}
  photos: any[];
  totalCount: number;
  endCursor: string = null;
  entityType: string;
  credit = "";
  loading = false;
  locations: any[];
  attractions: any[];
  selectedLocationId: string;
  selectedAttractionId: string;
  idLabel: string;
  premium: boolean;
  private: boolean;
  gallery: any[];
  meetTheLocals: any[];
  featuredImage: any[];
  description: string;
  publishedAttraction: boolean;
  publishedLocation: boolean;
  filteredAttractions: any[];
  filteredLocations: any[];
  creditChanged: Subject<string> = new Subject<string>();

  ngOnInit() {
    this.pageIndex = 0;
    this.getAllPhotos();
    this.getAllAttraction();
    this.getAllLocation();

    this.creditChanged
      .pipe(debounceTime(1500))
      .subscribe((model) => this.filter());
  }

  dataChanged() {
    this.creditChanged.next();
  }
  getAllPhotos() {
    let obj: any;
    obj = {
      paginationData: {
        pageIndex: this.pageIndex,
        pageSize: AppConstants.DEFAULT_PHOTOS_PAGE_SIZE,
        ...(this.pageIndex > 0 && this.endCursor
          ? { after: this.endCursor }
          : {}),
      },
    };

    if (this.credit.length > 0) {
      obj.credit = this.credit;
    }
    if (this.selectedLocationId && this.selectedLocationId !== "all") {
      obj.locationId = this.selectedLocationId;
    } else if (
      this.selectedAttractionId &&
      this.selectedAttractionId !== "all"
    ) {
      obj.attractionId = this.selectedAttractionId;
    }

    if (this.premium) obj.premium = this.premium;
    if (this.private) obj.private = this.private;
    this.loading = true;
    this.graphqlService.getAllPhotos(obj).subscribe((res) => {
      const data = res.data;
      console.log("photo", data);

      if (data && data["photos"]) {
        this.endCursor = data["photos"].pageInfo.endCursor;
        this.pageIndex++;

        this.totalCount = data["photos"].totalCount;
        if (this.pageIndex === 1) {
          this.photos = data["photos"].edges.map((edge) => edge.node);
        } else {
          this.photos = this.photos.concat(
            data["photos"].edges.map((edge) => edge.node)
          );
        }

        this.utilsService.openSnackBar("Photos Loaded !!", "");
      }

      this.loading = false;
    });
  }

  getAllLocation() {
    this.locationService.getAllLocation().subscribe((res) => {
      const data = res.data;
      if (data && data["allLocations"]) {
        this.locations = this.filteredLocations = data["allLocations"];
      }
    });
  }

  changeLocation() {
    this.selectedAttractionId = "";
    this.idLabel = "locationId";
    this.filter();
    this.getLocationImages(this.selectedLocationId);
  }

  getAllAttraction() {
    this.attractionService.getAllAttraction().subscribe((res) => {
      const data = res.data;
      if (data && data["allAttractions"]) {
        this.attractions = this.filteredAttractions = data["allAttractions"];
      }
    });
  }
  changeAttraction() {
    this.selectedLocationId = "";
    this.idLabel = "attractionId";
    this.filter();
    this.getAttractionImages(this.selectedAttractionId);
  }

  loadMore() {
    this.pageIndex++;
    this.getAllPhotos();
  }

  filter() {
    this.endCursor = null;
    this.pageIndex = 0;
    this.getAllPhotos();
  }
  photoChanged(index) {
    if (!this.loading && index + 5 >= this.photos.length) {
      this.loadMore();
    }
  }

  getId() {
    if (this.selectedLocationId) {
      return this.selectedLocationId;
    } else if (this.selectedAttractionId) {
      return this.selectedAttractionId;
    }
  }

  getAttractionImages(id: string) {
    this.gallery = [];
    this.meetTheLocals = [];
    this.description = null;
    this.featuredImage = null;
    this.attractionService.getAttractionGallery(id).subscribe((res) => {
      console.log("resdata", res);
      if (res && res["data"] && res["data"]["attraction"]["gallery"]) {
        this.gallery = res["data"]["attraction"]["gallery"];

        this.utilsService.openSnackBar("Gallery Loaded !!", "");
        this.meetTheLocals = res["data"]["attraction"]["meetTheLocals"];
        this.featuredImage = res["data"]["attraction"]["featuredPhoto"];
        this.description = res["data"]["attraction"]["description"];
      }
    });
  }
  getLocationImages(id: string) {
    this.gallery = [];
    this.meetTheLocals = [];
    this.description = null;
    this.featuredImage = null;
    this.locationService.getLocationGallery(id).subscribe((res) => {
      if (res && res["data"] && res["data"]["location"]["gallery"]) {
        this.gallery = res["data"]["location"]["gallery"];
        this.description = res["data"]["location"]["description"];

        this.utilsService.openSnackBar("Gallery Loaded !!", "");
        this.meetTheLocals = res["data"]["location"]["meetTheLocals"];
        this.featuredImage = res["data"]["location"]["featuredPhoto"];
      }
    });
  }
  updateGallery(file) {
    let img = {
      id: file.id,
      path: file.path,
      url: file.url,
    };
    let exist = this.gallery.find((obj) => obj.id === file.id);
    if (!exist) {
      this.gallery = [...this.gallery, img];
    }
  }

  updateMeetTheLocals(file) {
    let exist = this.meetTheLocals.find((obj) => obj.id === file.id);
    if (!exist) {
      let img = {
        id: file.id,
        path: file.path,
        url: file.url,
      };
      this.meetTheLocals = [...this.meetTheLocals, img];
    }
  }

  galleryOrderChanged(event) {
    const galleryOrder = event.map((image, index) => {
      return {
        imageId: image.id,
        sortOrder: index,
      };
    });
    const data = {
      [this.idLabel]: this.getId(),
      files: galleryOrder,
      idLabel: this.idLabel,
    };
    this.fileService.updateGalleryOrder(data).subscribe(
      (res) => {
        this.utilsService.openSnackBar("Order updated Successfully!", "");
      },
      (err) => {
        this.utilsService.openSnackBar("Error while updating Order!", "");
      }
    );
  }
  removeFromGallery(file) {
    const data = {
      [this.idLabel]: this.getId(),
      idLabel: this.idLabel,
      imageId: file.id,
    };
    this.fileService.removeFromGallery(data).subscribe(
      (res) => {
        let gallery = [...this.gallery];
        gallery.splice(gallery.indexOf(file), 1);
        this.gallery = gallery;
        ///Gallery is read only
        // this.gallery.splice(this.gallery.indexOf(file), 1);
        this.utilsService.openSnackBar(
          "Image removed from Gallery Successfully!!",
          ""
        );
      },
      (err) => {
        this.utilsService.openSnackBar("Error removing image to Gallery!!", "");
      }
    );
  }

  removeFromMeetTheLocal(file) {
    const data = {
      [this.idLabel]: this.getId(),
      idLabel: this.idLabel,
      imageId: file.id,
    };
    this.fileService.removeFromMeetTheLocal(data).subscribe(
      (res) => {
        let meetTheLocals = [...this.meetTheLocals];
        this.meetTheLocals = [];
        meetTheLocals.splice(meetTheLocals.indexOf(file), 1);
        this.meetTheLocals = meetTheLocals;

        this.utilsService.openSnackBar(
          "Meet the local removed successfully!",
          ""
        );
      },
      (err) => {
        this.utilsService.openSnackBar("Error removing meet the local!", "");
      }
    );
  }
  updateFeaturedImage(file) {
    this.featuredImage = file;
  }

  filterAttractions() {
    this.filteredAttractions = this.publishedAttraction
      ? this.attractions.filter((attraction) => {
          if (attraction.published) return attraction;
        })
      : this.attractions;
  }

  filterLocations() {
    this.filteredLocations = this.publishedLocation
      ? this.locations.filter((location) => {
          if (location.published) return location;
        })
      : this.locations;
  }
}



// WEBPACK FOOTER //
// /Users/ugyen/Documents/Bhutan-office/my_bhutan/mybhutan-travel/src-admin/app/components/all-photos/all-photos.component.ts